module.exports = __webpack_public_path__ + "img/iconDownload.6d768d01.png";